import { useCallback, useEffect, useState } from 'react';

import { FeatureFlagList } from './featureFlagList';
import { FeatureFlagManager } from './featureFlagManager';

/**
 * Hook to return the current state of the given LaunchDarkly feature flag.
 * Updates when the flag changes, if change occurs locally via an override.
 *
 * @param {string} flag The specific feature flag to check. Defaults to value
 *                      from FeatureFlagList.
 */
export const useFeatureFlag = <T extends string = FeatureFlagList>(flag: T) => {
  const featureFlagManager = FeatureFlagManager.FFManInstance;

  const [val, setVal] = useState<boolean>(featureFlagManager.isEnabled(flag));

  const onFlagsChanged = useCallback(() => {
    setVal(featureFlagManager.isEnabled(flag));
  }, [featureFlagManager, flag]);

  useEffect(() => {
    featureFlagManager.on('change', onFlagsChanged);
    onFlagsChanged();
    return () => {
      featureFlagManager.off('change', onFlagsChanged);
    };
  }, [featureFlagManager, onFlagsChanged]);

  return val;
};
